package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.outlined.CheckCircle
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.model.LibraryMovie
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import com.sweetlime.bingeamigo.presentation.features.library.LibraryViewModel
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun WatchedButton(
    libraryMovie: LibraryMovie,
    libraryViewModel: LibraryViewModel = koinViewModel(),
) {
    val watched by libraryViewModel.watched.collectAsState()
    val uiState by libraryViewModel.uiState.collectAsState()
    val isWatched = watched.any { it.id == libraryMovie.id }
    var isLoading by remember { mutableStateOf(false) }

    LaunchedEffect(isWatched) { isLoading = false }
    LaunchedEffect(uiState) {
        if (uiState is com.sweetlime.bingeamigo.state.LibraryUiState.Error) {
            isLoading = false
            libraryViewModel.clearError()
        }
    }

    Button(
        modifier = Modifier.fillMaxWidth(),
        onClick = {
            if (isLoading) return@Button
            isLoading = true
            if (isWatched) {
                libraryViewModel.removeFromWatched(libraryMovie)
            } else {
                libraryViewModel.markAsWatched(libraryMovie)
            }
        },
        colors = if (isWatched)
            ButtonDefaults.buttonColors(containerColor = BrandColors.Primary, contentColor = Color.Black)
        else
            ButtonDefaults.buttonColors(containerColor = Color.Transparent, contentColor = Color.White),
        border = if (!isWatched) BorderStroke(1.dp, Color.White.copy(alpha = 0.4f)) else null,
    ) {
        when {
            isLoading -> CircularProgressIndicator(
                modifier = Modifier.size(18.dp),
                strokeWidth = 2.dp,
                color = Color.White,
            )
            isWatched -> Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Icon(imageVector = Icons.Filled.CheckCircle, contentDescription = null)
                Spacer(modifier = Modifier.width(6.dp))
                Text("Watched")
            }
            else -> Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Icon(imageVector = Icons.Outlined.CheckCircle, contentDescription = null)
                Spacer(modifier = Modifier.width(6.dp))
                Text("Mark as Watched")
            }
        }
    }
}